import { colorInterpolationProvider } from "./color-interpolator/colorInterpolationProvider";
import { colorStringParserProvider } from "./color-string-parser/colorStringParserProvider";
import { pixelAccessorProvider } from "./pixel-accessor/pixelAccessorProvider";
import { createServiceContainer } from "./service-container/createServiceContainer";
import { colorResamplerProvider } from "./color-resampler/colorResamplerProvider";
import { distortionProcessingProvider } from "./distortion-processing/distortionProcessingProvider";
import { imageAdapterProvider } from "./image-adapter/imageAdapterProvider";
import { outputViewportStrategyProvider } from "./output-viewport-strategy/outputViewportStrategyProvider";
import { pixelMappingProvider } from "./pixel-mapper/pixelMappingProvider";
import { resampleFilterProvider } from "./resample-filter/resampleFilterProvider";
import { weightingFunctionProvider } from "./weighting-function/weightingFunctionProvider";

export const serviceContainer = createServiceContainer([
  colorResamplerProvider,
  colorStringParserProvider,
  distortionProcessingProvider,
  imageAdapterProvider,
  outputViewportStrategyProvider,
  pixelMappingProvider,
  resampleFilterProvider,
  weightingFunctionProvider,
  colorInterpolationProvider,
  pixelAccessorProvider,
]);
